import React, { useEffect, useState } from "react";
import styles from "./AllDevices.module.css";
import useAuthToken from "../../../hooks/useAuthToken";
import { useNavigate } from "react-router-dom";
import { fetchDeviceService, deleteDevice } from "./fetchDeviceService";
import { useToast } from "../../../context/ToastContext";
import trash from "../../../img/trash.svg";

const AllDevices = () => {
    const navigate = useNavigate();
    const token = useAuthToken();
    const [devices, setDevices] = useState([]);
    const [sn, setSn] = useState("");
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(20);
    const [totalPages, setTotalPages] = useState(1);

    const { setToast } = useToast();

    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };


    useEffect(() => {
        console.log("UPDATE")
        fetchDevices(); // Вызываем сразу при монтировании

        const interval = setInterval(() => {
            fetchDevices();
        }, 15000); // 10 секунд

        return () => clearInterval(interval); // Очищаем интервал при размонтировании
    }, [sn, page]);

    async function fetchDevices() {
        if (!token) return;
        const resp = await fetchDeviceService(token, sn, page, size);
        // console.log(resp)
        if (resp) {
            setDevices(resp.content);
            setTotalPages(resp.totalPages); // <-- добавили
        }
    }

    const handleDelete = async (sn) => {
        const resp = await deleteDevice(sn, token);
        console.log(resp);
        showToast(resp.result, "success", 3000);
    };

    const handleClick = (device) => {
        navigate('/cardDevice', { state: { device } });
    };

    const handleAddDevice = () => {
        // showToast("Добавить устройство", "success", 5000);
        navigate("/addDevice")
    };

    const handleUploadFirmware = () => {
        // showToast("Добавить устройство", "success", 5000);
        navigate("/uploadFirmware")
    };



    return (
        <div className={styles.container}>
            <h3>Ваши устройства</h3>
            <div className={styles.panel}>
                <input
                    className={styles.snInput}
                    type="text"
                    placeholder="Введите серийный номер"
                    required
                    value={sn}
                    onChange={(e) => setSn(e.target.value)}
                />
                <dev className={styles.actions}>
                    <button
                        className={styles.addButton}
                        onClick={handleAddDevice}>
                        <p className={styles.buttonText}>Добавить устройство</p>
                    </button>
                    <button
                        className={styles.addButton}
                        onClick={handleUploadFirmware}>
                        <p className={styles.buttonText}>Загрузить прошивку</p>
                    </button>
                </dev>

            </div>


            {devices.length === 0 ? (
                <p className={styles.noDevices}>Нет устройств</p>
            ) : (
                <div className={styles.tableWrapper}>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Serial number</th>
                                <th>Topic</th>
                                <th>Type</th>
                                <th>Status</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            {devices.map((device) => (
                                <tr key={device.sn}
                                    onClick={() => handleClick(device)}
                                >
                                    <td>{device.sn}</td>
                                    <td>{device.topic}</td>
                                    <td>{device.type}</td>
                                    <td> <div className={device.isAlive || device.isAlive != null
                                        ? styles.statusCircleGreen
                                        : styles.statusCircleRed}></div>
                                    </td>
                                    <td>
                                        <img
                                            src={trash}
                                            alt="trash"
                                            className={styles.trashIcon}
                                            onClick={(e) => {
                                                e.stopPropagation(); // Останавливает клик по <tr>
                                                handleDelete(device.sn);
                                            }}
                                        /></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {totalPages > 1 && (
                <div className={styles.pagination}>
                    <button
                        disabled={page === 0}
                        onClick={() => setPage((prev) => prev - 1)}
                    >
                        ← Назад
                    </button>
                    <span>{page + 1} / {totalPages}</span>
                    <button
                        disabled={page + 1 === totalPages}
                        onClick={() => setPage((prev) => prev + 1)}
                    >
                        Вперёд →
                    </button>
                </div>
            )}

        </div>
    )
}

export default AllDevices;